export function getWidgetProps (type) {
  const properties = {}
  switch (type) {
    case 'LmListBuilder':
      properties.name = 'Listado con ListBuilder'
      properties.dataOrigin = []
      properties.sizes = [12]
      break
    case 'LmTitleBuilder':
      properties.name = 'Título'
      properties.title = 'Un gran título separador'
      properties.sizes = [12]
      break
    default:
      break
  }
  return properties
}

export function getWidgetCustomizationProps (widget) {
  const customization = {}
  switch (widget) {
    case 'LmList':
      customization.color = ''
      customization.size = ''
      break
    case 'LmTitle':
      customization.title = 'Un gran título separador'
      customization.size = ''
      break
    default:
      break
  }
  return customization
}
